import { Component, OnInit, Input } from '@angular/core';
import { CoreTaskService } from '../core-task.service';
import { Subscription } from 'rxjs/Subscription';
import { CoreTask } from '../../students/core-task';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
    @Input('examinationId') examinationId;

    public coreTask;
    private coreTask$: Subscription;

    constructor(private coreTaskService: CoreTaskService) { }

    ngOnInit() {
        this.coreTask$ = this.coreTaskService.getCoreTaskByStudentCreboId(this.examinationId).subscribe(data => {
            this.coreTask = data;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/examination/summary/summary.component.ts